define('bizzabo/views/PollsCollectionView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/views/CollectionView',
    'bizzabo/views/PollView'

], function(
    $,
    Backbone,
    _,
    CollectionView,
    PollView

    ) {

    var PollsCollectionView = CollectionView.extend({
        ItemView: PollView,

        //Override to add parentView
        renderSubViewWithModel: function(model) {
            var subView = new this.ItemView({
                model: model,
                pollsView: this.options.pollsView
            });
            this.addSubView(subView);
            this.$el.append(subView.render().$el);
        }
    });

    return PollsCollectionView;

});
